import { render, staticRenderFns } from "./TimeslotCollectionPopover.vue?vue&type=template&id=39c66c56&"
import script from "./TimeslotCollectionPopover.vue?vue&type=script&lang=js&"
export * from "./TimeslotCollectionPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports